import { useState } from 'react';
import { Button, Select, Toggle } from '@nazka/nazka.mapframe.components';

import HelpTooltip from '@App/components/HelpTooltip/HelpTooltip';

import EditMobilityFieldModal from '../EditMobilityFieldModal/EditMobilityFieldModal';

import './activated-mobility-field.styl';

function MobilityField({ field, onUpdateField, isChild }) {
  if (isChild && field.dataType === 'boolean') {
    return (
      <Toggle
        checked={field.value ?? false}
        onInputChange={(e) => {
          onUpdateField(field.name, e.target.checked);
        }}
        label={field.displayName}
        rootElProps={{ onClick: e => e.stopPropagation() }}
        className="mobility-field__toggle"
      />
    );
  }

  if (field.fieldType === 'drop-down') {
    return (
      <div className="mobility-field__drop-down">
        <span>
          {`${field.displayName}: `}
        </span>
        <Select
          options={Object.keys(field.enum).map(key => ({ id: key, label: field.enum[key] }))}
          value={field.value ? String(field.value) : undefined}
          onInputChange={(value) => {
            onUpdateField(field.name, value.id);
          }}
          rootElProps={{ onClick: e => e.stopPropagation() }}
          className="mobility-field__drop-down__select"
        />
      </div>
    );
  }

  return (
    <span>
      {field.displayName}
    </span>
  );
}

function ActivatedMobilityField({
  field,
  isChild = false,
  onClick,
  onUpdateField,
  selected,
  showSupplements = true,
}) {
  const [editingField, setEditingField] = useState(undefined);

  const visibleChildren = field.children ? field.children.filter(child => child.fieldType !== 'supplement') : undefined;
  const supplement = field.children ? field.children.find(child => child.fieldType === 'supplement') : undefined;

  return (
    <>
      <li
        className={`activated-mobility-field${selected ? ' activated-mobility-field--selected' : ''}`}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        <div className="activated-mobility-field__name">
          <MobilityField
            field={field}
            onUpdateField={onUpdateField}
            isChild={isChild}
          />
          {showSupplements && supplement && field.value && (
            <Button
              layout="outlined"
              className="activated-mobility-field__supplement"
              onClick={(e) => {
                e.stopPropagation();
                setEditingField({ field: supplement, title: field.displayName });
              }}
            >
              {`${supplement.value ?? '?'} ${supplement.unit ?? ''}`}
            </Button>
          )}
          {field.helpText && (
            <HelpTooltip helpText={field.helpText} id={field.name} />
          )}
        </div>
        {visibleChildren && (
          <ul>
            {visibleChildren.map((child) => {
              return (
                <ActivatedMobilityField
                  key={child.name}
                  field={child}
                  onUpdateField={onUpdateField}
                  isChild
                  showSupplements={showSupplements}
                />
              );
            })}
          </ul>
        )}
      </li>
      {editingField && (
        <EditMobilityFieldModal
          field={editingField.field}
          title={editingField.title}
          onConfirm={(value) => {
            onUpdateField(editingField.field.name, value);
            setEditingField(undefined);
          }}
          onCancel={() => {
            setEditingField(undefined);
          }}
        />
      )}
    </>
  );
}

export default ActivatedMobilityField;
